module.exports = __webpack_public_path__ + "static/media/grafik_Fig1-6.f39f1559.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/grafik_Fig1-6.png
// module id = 695
// module chunks = 0